var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwaitSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167460",
    "data-name": "Group 167460",
    transform: "translate(-157 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167250",
    "data-name": "Group 167250",
    transform: "translate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83260",
    "data-name": "Path 83260",
    d: "M40,0C71.046,0,80,8.954,80,40S71.046,80,40,80,0,71.046,0,40,8.954,0,40,0Z",
    transform: "translate(171 211)",
    fill: "#eff5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(177 231)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9416",
    "data-name": "Ellipse 9416",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#357bf7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83285",
    "data-name": "Path 83285",
    d: "M12,6V16.8l7.2,3.6",
    transform: "translate(8 3.2)",
    fill: "none",
    stroke: "#357bf7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitSendIcon);
export default __webpack_public_path__ + "static/media/await_send_icon.df56c044ea86aed67d8db7410089b30e.svg";
export { ForwardRef as ReactComponent };